<template>
	<div class="per_right">
		<div class="per_right_1 clearfix">
			<img src="@/images/center_title.png" class="per_right_1back" />
			<img src="@/images/center_text14.png" class="per_right_1name" />
		</div>
		<div class="per_right_2">
			<div class="right-filter">
				<!--<el-form :inline="true" :model="form">
					<el-form-item label="作业状态：">
						<el-select v-model="form.state" placeholder="作业状态">
							<el-option :label="item.label" :value="item.value" :key="item.value" v-for='item in types'></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="作业名称：">
						<el-input v-model="form.examineName" placeholder="请输入作业名称关键词"></el-input>
					</el-form-item>
					<el-form-item>
						<div class="feedback_button" @click="onSubmit">
							<img src="@/images/zy_button.png" class="feedback_back" />
							<span>查询</span>
						</div>
					</el-form-item>
				</el-form>-->
			</div>
			<div class="task_right_bottom">
				<el-table :data="testList" stripe style="width: 100%">
					<el-table-column label="课程" align="center">
						<template slot-scope="scope">
							{{scope.row.courseName}}
						</template>
					</el-table-column>
					<el-table-column label="创建时间" align="center">
						<template slot-scope="scope">
							{{scope.row.createTime | spliceForHalfData}}
						</template>
					</el-table-column>
					<el-table-column label="操作" width='150' align="center">
						<template slot-scope="scope">
							<el-button size="mini" type="primary" @click="testit(scope.row)" v-if='scope.row.submit != "1"'>进入测验</el-button>
							<el-button size="mini" type="primary" @click="testitinfo(scope.row)" v-if='scope.row.submit == "1"'>查看测验</el-button>
						</template>
					</el-table-column>
				</el-table>
				<div class="table-page">
					<el-pagination background @current-change="testPageChange" :current-page="testPage" :page-size="pageSize" layout="  prev, pager, next, jumper" :total="testtotalRow">
					</el-pagination>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import { testlist } from '@/api/test.js'
	export default {
		data() {
			return {
				//常规
				pageSize: 20,
				form: {
					examineName: '',
					state: '',
				},
				types: [{
					value: '',
					label: '全部'
				}, {
					value: '0',
					label: '已完成'
				}, {
					value: '1',
					label: '延时提交'
				}, {
					value: '2',
					label: '未完成'
				}],
				//作业
				testPage: 1,
				testtotalRow: 0,
				testList: [],
			};
		},
		created() {
			this.getTestList();
		},
		methods: {
			testPageChange(page) {
				this.testPage = page;
				this.getTestList()
			},
			getTestList() {
				var data = {
					pageSize: this.pageSize,
					page: this.testPage
				}
				testlist(data).then(res => {
					if(res.code == 0) {
						this.testtotalRow = res.data.totalRow;
						this.testList = res.data.listData
					}
				})
			},
			onSubmit() {

			},
			testit(item) {
				this.$router.push({
					name: 'test',
					query: {
						testId: item.id,
						coursename: item.courseName
					}
				})
			},
			testitinfo(item) {
				this.$router.push({
					name: 'testdetails',
					query: {
						testId: item.id,
						coursename: item.courseName
					}
				})
			},
		},
	};
</script>

<style>

</style>